import React from 'react';
import { IonChip, IonLabel, IonText } from '@ionic/react';
import { ExistingTag } from './useExistingCareMapTags';

interface YourTagsSectionProps {
    tags: ExistingTag[];
    searchText: string;
    onTagClick: (
        tagName: string,
        source: 'suggested' | 'your_tags' | 'custom',
        totalSuggestions?: number
    ) => void;
    getTagColor: (tag: string) => { backgroundColor: string; color: string; border: string };
    className?: string;
    loading?: boolean;
    totalSuggestions?: number;
}

/**
 * Renders a tag name with bold highlighting for the matching search text
 */
const renderTagWithHighlight = (tagName: string, searchText: string): React.ReactNode => {
    if (!searchText.trim()) {
        return tagName;
    }

    const searchLower = searchText.toLowerCase();
    const tagLower = tagName.toLowerCase();
    const index = tagLower.indexOf(searchLower);

    if (index === -1) {
        return tagName;
    }

    const before = tagName.slice(0, index);
    const match = tagName.slice(index, index + searchText.length);
    const after = tagName.slice(index + searchText.length);

    return (
        <>
            {before}
            <strong>{match}</strong>
            {after}
        </>
    );
};

export const YourTagsSection: React.FC<YourTagsSectionProps> = ({
    tags,
    searchText,
    onTagClick,
    getTagColor,
    className = '',
    loading = false,
    totalSuggestions = 0
}) => {
    if (tags.length === 0 && !loading) {
        return null;
    }

    return (
        <div className={`suggestion-group ${className}`}>
            <IonText color="medium" className="suggestion-title">
                <small>YOUR TAGS</small>
            </IonText>
            <div className="suggestion-chips">
                {loading && tags.length === 0 ? (
                    <IonText color="medium">
                        <small>Loading your tags...</small>
                    </IonText>
                ) : (
                    tags.map((tag, _index) => (
                        <IonChip
                            key={tag.name}
                            className="suggestion-chip existing-tag-chip"
                            style={getTagColor(tag.name)}
                            onClick={() => onTagClick(tag.name, 'your_tags', totalSuggestions)}
                        >
                            <IonLabel style={{ fontSize: '14px' }}>
                                <span className="tag-name">
                                    {renderTagWithHighlight(tag.name, searchText)}
                                </span>
                                <span className="tag-count"> ({tag.count})</span>
                            </IonLabel>
                        </IonChip>
                    ))
                )}
            </div>
        </div>
    );
};
